<div class="db-one-week-free-demo__option {{activeTab}}"
     [ngClass]="{
       'most-popular': mostPopular,
       'active': mostPopular,
     }">
  <div class="plan-content" [ngClass]="{'preselected': singlePlanMode, 'paid': isPaid, 'with-btn': !isPaid, 'with-offer': applyCouponForPlatform && !isPaid}">
<!--   <div class="plan-radio" *ngIf="!isPaid && radioBtnVersion">
      <input type="radio"
             class="ds-radio ds-radio-bg"
             [checked]="isSelected"
             [name]="'plan-' + activeTab"
             [id]="'plan-' + title"
             [attr.aria-label]="'Select ' + title + ' plan'">
      <label [for]="'plan-' + title"></label>
    </div>-->
    @if (!singlePlanMode) {
      <div class="db-best" *ngIf="mostPopular">BEST VALUE</div>
      <div class="db-one-week-free-demo__option-header">
        <h1 *ngIf="title">{{ title }}</h1>
      </div>

      <div class="db-one-week-free-demo__option-price">
        <div class="price-container" [ngClass]="{invisible: hasCampaignCoupon && !applyCouponForPlatform}">
          <h1>
               <span *ngIf="hasCampaignCoupon && !!couponPercent" class="db-lined">
          ${{
                   (subscription?.plan?.planPrice / periodSwitchValue) | DbNumberFormatPipe:
                     periodSwitchValue === 12 || applyCouponForPlatform ? 'ceil' : 'floor'
                 }}
        </span>
            ${{ (subscription?.plan?.planPrice * (100 - couponPercent) / 100) / periodSwitchValue | DbNumberFormatPipe:
            hasCampaignCoupon ? 'precise' : 'floor' }}<span class="period">/mo</span>
          </h1>
        </div>

        <p *ngIf="applyCouponForPlatform && !!couponPercent"  [ngClass]="{fadeIn: hasCampaignCoupon && !applyCouponForPlatform}"
           class="mb4 mt6">{{couponPercent}}% off on your first payment</p>
        <p class="billing-period">Billed {{ periodSwitchValue === 12 ? 'annually' : 'monthly' }}</p>
        <div class="plan-description" *ngIf="planDesc">{{ planDesc }}</div>
        <button class="ds-btn-black ds-btn-max mt24" (click)="selectPlan()">
          <span>{{ isPaid ? 'Upgrade Now' : 'Try for Free' }}</span>
        </button>
      </div>
    }

    <div class="db-one-week-free-demo__plan-info">
      <!-- Main Features -->
      <div class="feature-list {{singlePlanMode ? 'mb14' : 'mb24'}}">
        <div *ngFor="let feature of getPlanFeatures('mainFeaturesNew')"
             class="feature-item" [class.has-video]="feature?.hasVideo"  [dsTooltipSize]="'small'"
             [dsTooltipMode]="'hoverStatic'" [dsTooltipVisible]="feature?.hasVideo && !showFirstTime" [dsTooltip]="copilot"
             [dsTooltipWithVideo]="true"
             [dsTooltipPosition]="'bottom'"
             [dsTooltipAlign]="'left'"
             [hostClass]="'cover-all'">
          <div>
            <span class="feature-icon">
              <i class="db-icon db-icon-ds-checkmark-sharp"></i>
            </span>
            <span class="feature-text" [innerHTML]="feature?.text">
            </span>
            <span class="feature-video" *ngIf="feature?.hasVideo"><i class="db-icon db-icon-ds-play-small" ></i></span>
          </div>
          <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
            monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
            ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
            aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
            cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
            websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
            period: periodSwitchValue === 12 ? '1 year' : '1 month'
          })"></span>
        </div>
      </div>

      <!-- Everything in Previous Plan -->
      <ng-container *ngIf="getPlanFeatures('everythingInPrevious')">
        <div class="feature-section mt24">
          <h3>Everything in {{ getPlanFeatures('everythingInPrevious').previousPlan }} Plus</h3>
          <div class="feature-list">
            <div *ngFor="let feature of getPlanFeatures('everythingInPrevious').features" class="feature-item">
              <div>
                <span class="feature-icon">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                </span>
                <span class="feature-text" [innerHTML]="feature?.text">
                </span>
              </div>
              <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitchValue === 12 ? '1 year' : '1 month'
              })"></span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Secondary Features -->
      <ng-container *ngIf="getPlanFeatures('secondaryFeatures')">
        <div class="feature-section {{singlePlanMode ? 'mt0 ': 'mt24'}}" [ngClass]="{'preselected': singlePlanMode}">
          <div class="feature-list">
            <div *ngFor="let feature of getPlanFeatures('secondaryFeatures')" class="feature-item">
              <div>
                <span class="feature-icon">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                </span>
                <span class="feature-text" [innerHTML]="feature?.text">
                </span>
              </div>
              <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitchValue === 12 ? '1 year' : '1 month'
              })"></span>
              <div *ngIf="feature.hasImages" class="db-image">
                <img src="assets/images/logos/payment-methods.svg"/>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Platform Features -->
      <ng-container *ngIf="getPlanFeatures('platformFeatures')">
        <div class="feature-section__secondary mt24">
          <h3>Platform Features</h3>
          <div class="feature-list">
            <div *ngFor="let feature of getPlanFeatures('platformFeatures')" class="feature-item">
              <div>
                <span class="feature-icon">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                </span>
                <span class="feature-text" [innerHTML]="feature?.text">
                </span>
              </div>
              <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitchValue === 12 ? '1 year' : '1 month'
              })"></span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #copilot>
  <div class="video-tooltip">
    <p>EXPLORE AI COPILOT FEATURES</p>
    <!-- Image Instead of Video -->
    <div  class="video-thumbnail" (click)="openVideoPopup()">
      <img src="assets/images/upgrade-plan/copilot_iframe.jpg"
           alt="Explore AI Copilot Features"/>
      <i class="db-icon db-icon-ds-media-play"></i>
    </div>
  </div>

</ng-template>

